class axiosUrl {
  getAxiosUrl() {
    return "/api/";
  }
}

export default new axiosUrl();
